import styled from "styled-components";
import { Box } from "@pochta/ui";
export var ErrorPageMain = styled.main.withConfig({
  displayName: "ErrorPagestyles__ErrorPageMain",
  componentId: "sc-xkcvbn-0"
})(["box-sizing:border-box;*,::after,::before,*::after,*::before{box-sizing:inherit;}background-color:", ";height:100vh;"], function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutralsBlack.hex5;
});
export var ErrorPageWrapper = styled(Box).withConfig({
  displayName: "ErrorPagestyles__ErrorPageWrapper",
  componentId: "sc-xkcvbn-1"
})(["padding-top:170px;padding-bottom:100px;"]);
export var ErrorPageQr = styled.a.withConfig({
  displayName: "ErrorPagestyles__ErrorPageQr",
  componentId: "sc-xkcvbn-2"
})(["display:inline-block;background-image:url(https://static.pochta.ru/errorPage/qr.svg);width:264px;height:264px;"]);
export var ErrorPageQrId = styled.a.withConfig({
  displayName: "ErrorPagestyles__ErrorPageQrId",
  componentId: "sc-xkcvbn-3"
})(["display:inline-block;background-image:url(https://static.pochta.ru/errorPage/qrId.svg);width:264px;height:264px;"]);
export var ErrorPageAppStore = styled.a.withConfig({
  displayName: "ErrorPagestyles__ErrorPageAppStore",
  componentId: "sc-xkcvbn-4"
})(["display:inline-block;background-image:url(https://static.pochta.ru/footer/images/appStore.svg);cursor:pointer;width:135px;height:40px;"]);
export var ErrorPageGooglePlay = styled.a.withConfig({
  displayName: "ErrorPagestyles__ErrorPageGooglePlay",
  componentId: "sc-xkcvbn-5"
})(["display:inline-block;background-image:url(https://static.pochta.ru/footer/images/googlePlay.svg);cursor:pointer;width:135px;height:40px;margin-left:17px;", "{margin-left:0;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.mobile;
});